/// \file depotManagementRoutes.tsx
///
/// \par Copyright Notice:
/// Copyright (c) 2024 by Oshkosh Corporation.
/// All Rights Reserved.
///
/// \par
/// The information contained herein is confidential and proprietary property
/// of Oshkosh Corporation, and may be privileged.  The dissemination,
/// distribution, use, copying, transfer, or disclosure of such information is
/// strictly prohibited except by express written agreement with Oshkosh
/// Corporation, or with one of its subsidiaries.


import {lazy, Suspense} from "react";
import { ActionFunctionArgs, LoaderFunctionArgs, Route } from "react-router-dom";

const DepotManagementList = lazy(() => import('../views/depot-management/list/view'));

const routes = (
  <Route
    path="DepotManagement"
    handle={{
      text: 'Depot Management'
    }}
  >
    <Route
      index
      element={
        <Suspense fallback={<div>Loading...</div>}>
          <DepotManagementList />
        </Suspense>
      }
      />
  </Route>
);

export default routes;